import React, { useState, useRef, memo, Fragment } from 'react'
import PropTypes from 'prop-types'
import { List, Map, OrderedMap } from 'immutable'

import fridgeStyle from '@aytm/app/swidget/questions/styles/sh/fridge.module.scss'
import walmartLeftDoor from '@aytm/app/swidget/questions/images/walmartFridge-left.svg'
import walmartRightDoor from '@aytm/app/swidget/questions/images/walmartFridge-right.svg'
import Shelves from '@aytm/app/swidget/questions/components/sh/shelves'

import { SETTINGS } from '@aytm/app/swidget/questions/components/sh/settings'

// import scrollTo from '@aytm/lib/common/scroll'

Fridge.propTypes = {
  questionSchema: PropTypes.instanceOf(Map).isRequired,
  fullscreen: PropTypes.bool,
  doors: PropTypes.bool,
  mobile: PropTypes.bool,
  generateImage: PropTypes.bool,
  emulatedMobile: PropTypes.bool,
  externalHover: PropTypes.bool,
  widthFactor: PropTypes.number.isRequired,
  scale: PropTypes.number.isRequired,
  answers: PropTypes.instanceOf(OrderedMap).isRequired,
  width: PropTypes.number.isRequired,
  cartCount: PropTypes.number,
  takenGoods: PropTypes.instanceOf(List).isRequired,
  onProductClick: PropTypes.func,
  onHovered: PropTypes.func,
  onRender: PropTypes.func,
  answersImages: PropTypes.any,
  margins: PropTypes.object,
  blockWidths: PropTypes.array
}

export function Fridge(props) {
  const { questionSchema, mobile, scale, width, blockWidths, margins, externalHover, onHovered, emulatedMobile } = props

  const [closedFridge, setClosedFridge] = useState(List([true, true]))
  const settings = {
    ...questionSchema.get('shelf_config').toJS(),
    ...SETTINGS[questionSchema.get('store')][questionSchema.get('shelf_type')],
    emulatedMobile: emulatedMobile
  }
  const alwaysOpen = 'find' == questionSchema.get('mode_type')

  const closeTheFridge = function (number) {
    const another = number ? 0 : 1
    setClosedFridge(
      closedFridge
        .set(number, !closedFridge.get(number))
        .set(another, closedFridge.get(number) ? true : closedFridge.get(another))
    )
  }

  const fridgeRef = useRef()

  // useEffect(() => {
  //   if (
  //     mobile &&
  //     fridgeRef &&
  //     fridgeRef.current &&
  //     fridgeRef.current.scrollWidth > 1.1 * fridgeRef.current.offsetWidth
  //   ) {
  //     scrollTo(fridgeRef.current, { left: fridgeRef.current.scrollWidth, duration: 2400 })
  //       .then(() => {
  //         setTimeout(() => {
  //           scrollTo(fridgeRef.current, {
  //             left: (fridgeRef.current.scrollWidth - fridgeRef.current.offsetWidth) / 4 + 5,
  //             duration: 1200
  //           })
  //         }, 800)
  //       })
  //       .catch(() => {})
  //   }
  // }, [mobile])

  const renderImages = function () {
    return (
      <Fragment>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              `
           .swidget-air-curtain  .swidget-fridge-content {
             background-image: url(` +
              require('./svg/air-curtain-wall-back.svg') +
              `);
              }

            .swidget-air-curtain  .swidget-fridge-content:before {
                background: url(` +
              require('./svg/air-curtain-wall-left.svg') +
              `);
              }

             .swidget-air-curtain  .swidget-fridge-content:after {
                background: url(` +
              require('./svg/air-curtain-wall-right.svg') +
              `);
              }

          .swidget-air-curtain  .swidget-fridge-bottom {
            background-image: url(` +
              require('./svg/air-curtain-foot-center.svg') +
              `);
              }

              .swidget-air-curtain  .swidget-fridge-bottom:before {
                background: url(` +
              require('./svg/air-curtain-foot-left.svg') +
              `);
              }

              .swidget-air-curtain  .swidget-fridge-bottom:after {
                background: url(` +
              require('./svg/air-curtain-foot-right.svg') +
              `);
              }

          .swidget-air-curtain  .swidget-fridge-top {
            background: url(` +
              require('./svg/air-curtain-top-center.svg') +
              `) !important;
              }

              .swidget-air-curtain  .swidget-fridge-top:before {
                background: url(` +
              require('./svg/air-curtain-top-left.svg') +
              `);
              }

              .swidget-air-curtain  .swidget-fridge-top:after {
                background: url(` +
              require('./svg/air-curtain-top-right.svg') +
              `);
              }
              .swidget-air-curtain  .swidget-fridge-curve-left {
                background: url(` +
              require('./svg/air-curtain-curve-left.svg') +
              `);
              }
              .swidget-air-curtain  .swidget-fridge-curve-right {
                background: url(` +
              require('./svg/air-curtain-curve-right.svg') +
              `);
              }
              .swidget-air-curtain  .swidget-fridge-curve-bottom-left {
                background: url(` +
              require('./svg/air-curtain-curve-bottom-left.svg') +
              `);
              }
              .swidget-air-curtain  .swidget-fridge-curve-bottom-right {
                background: url(` +
              require('./svg/air-curtain-curve-bottom-right.svg') +
              `);
              }
`
          }}
        />
      </Fragment>
    )
  }

  return (
    <div className={`${fridgeStyle.fridgeContainer}` + (mobile ? ` ${fridgeStyle.mobile}` : ``)} ref={fridgeRef}>
      {renderImages()}
      <div
        className={`${fridgeStyle.fridge} ${fridgeStyle[settings.styleClass]}`}
        data-testid="SW-SH-Fridge"
        style={{
          transform: 'scale(' + scale + ')',
          marginTop: margins.top,
          marginBottom: -margins.top,
          marginLeft: margins.left,
          minWidth: Math.round((settings.displayWidth || width) * scale * (questionSchema.get('double_width') ? 2 : 1))
        }}
      >
        <FridgeBox
          {...props}
          closeAnotherFridge={() => closeTheFridge(0)}
          closed={closedFridge.get(0)}
          first={true}
          emulatedMobile={emulatedMobile}
          externalHover={externalHover}
          onHovered={onHovered}
          hidden={questionSchema.get('double_width') && alwaysOpen}
          alwaysOpen={alwaysOpen}
          blockWidths={[0, (questionSchema.get('double_width') ? 1 : 1) * blockWidths[1]]}
        />
        {questionSchema.get('double_width') && (
          <FridgeBox
            {...props}
            closeAnotherFridge={() => closeTheFridge(1)}
            closed={closedFridge.get(1)}
            onHovered={onHovered}
            externalHover={externalHover}
            emulatedMobile={emulatedMobile}
            hidden={questionSchema.get('double_width') && alwaysOpen}
            blockWidths={[0, blockWidths[1]]}
          />
        )}
      </div>
    </div>
  )
}

const FridgeBox = memo(props => {
  const {
    questionSchema,
    doors,
    mobile,
    widthFactor,
    width,
    fullscreen,
    takenGoods,
    onProductClick,
    answers,
    closeAnotherFridge,
    closed,
    alwaysOpen,
    hidden,
    emulatedMobile,
    first,
    cartCount,
    externalHover,
    generateImage,
    onRender,
    answersImages,
    blockWidths,
    scale,
    onHovered
  } = props
  const settings = {
    ...questionSchema.get('shelf_config').toJS(),
    ...SETTINGS[questionSchema.get('store')][questionSchema.get('shelf_type')]
  }

  const fridgeRef = useRef()

  const switchDoors = function () {
    if (alwaysOpen || hidden) return
    if ('function' === typeof closeAnotherFridge) closeAnotherFridge()
  }

  const openDoors = doors && fridgeRef.current && (!closed || alwaysOpen) && scale <= 1 && !mobile && !hidden
  const closedDoors = doors && closed && !alwaysOpen && !hidden
  return (
    <div
      className={
        `${fridgeStyle.fridgeBox} ` +
        (questionSchema.get('double_width') ? (first ? `${fridgeStyle.left}` : `${fridgeStyle.right}`) : ``)
      }
    >
      {closedDoors && (
        <div
          className={fridgeStyle.fridgeDoors}
          onClick={switchDoors}
          data-testid="SW-SH-Fridge-ClosedDoors"
          style={{
            backgroundImage: 'url(' + require('./svg/doors.svg') + ')'
          }}
        >
          <div
            className={fridgeStyle.fridgeHandlers}
            style={{
              backgroundImage: 'url(' + require('./svg/handlers.svg') + ')'
            }}
          ></div>
        </div>
      )}
      {closedDoors && (
        <div
          className={fridgeStyle.fridgeLights}
          style={{
            backgroundImage: 'url(' + require('./svg/lights.svg') + ')'
          }}
        />
      )}
      <div
        className={fridgeStyle.fridgeContent}
        ref={fridgeRef}
        data-testid="SW-SH-Fridge-Content"
        style={{
          backgroundImage: settings.discrete
            ? 'url(' +
              require(
                questionSchema.get('double_width')
                  ? first
                    ? './svg/middle-left.svg'
                    : './svg/middle-right.svg'
                  : './svg/middle.svg'
              ) +
              ')'
            : 'auto'
        }}
      >
        <div
          style={{
            backgroundImage: settings.discrete
              ? 'url(' +
                require(
                  questionSchema.get('double_width')
                    ? first
                      ? './svg/top-left.svg'
                      : './svg/top-right.svg'
                    : './svg/top.svg'
                ) +
                ')'
              : 'auto'
          }}
          className={fridgeStyle.top}
        ></div>
        {openDoors && (
          <div
            className={fridgeStyle.leftDoorContainer}
            data-testid="SW-SH-Fridge-LeftDoor"
            style={{ height: fridgeRef.current.clientHeight + 40 }}
          >
            <img
              className={fridgeStyle.leftDoor}
              onClick={switchDoors}
              src={walmartLeftDoor}
              alt=""
              style={{
                display: doors ? 'block' : 'none',
                height: fridgeRef.current.clientHeight,
                transform:
                  fridgeRef.current.clientHeight < 547
                    ? 'scaleX(' + 580 / fridgeRef.current.clientHeight + ')'
                    : 'scaleY(' + fridgeRef.current.clientHeight / 547 + ')'
              }}
            />
          </div>
        )}
        {openDoors && (
          <div className={fridgeStyle.left}>
            <div
              className={fridgeStyle.fridgeOpenLights}
              style={{
                backgroundImage: 'url(' + require('./svg/reflection.svg') + ')'
              }}
            />
            <div
              className={fridgeStyle.handler}
              style={{
                backgroundImage: 'url(' + require('./svg/handler.svg') + ')'
              }}
            ></div>
          </div>
        )}
        <div
          className={fridgeStyle.fridgeShelves}
          style={{
            minHeight: Math.round(settings.height * widthFactor + settings.buttonWidth),
            width: settings.discrete ? Math.round((settings.width + settings.walls * 2) * widthFactor) : width
          }}
        >
          <Shelves
            questionSchema={questionSchema}
            fullscreen={fullscreen}
            mobile={mobile}
            widthFactor={widthFactor}
            width={width}
            onRender={onRender}
            answers={answers}
            takenGoods={takenGoods}
            emulatedMobile={emulatedMobile}
            onProductClick={onProductClick}
            onHovered={onHovered}
            first={first}
            last={!questionSchema.get('double_width') || !first}
            answersImages={answersImages}
            externalHover={externalHover}
            cartCount={cartCount}
            config={questionSchema.get('blocks_config').getIn([0, 'shelves'])}
            generateImage={generateImage}
            shelvesNumbers={[0, questionSchema.get('shelves_amount')]}
            blockWidths={blockWidths}
          />
        </div>
        {openDoors && (
          <div
            className={fridgeStyle.rightDoorContainer}
            data-testid="SW-SH-Fridge-RightDoor"
            style={{ height: fridgeRef.current.clientHeight + 40 }}
          >
            <img
              className={fridgeStyle.rightDoor}
              onClick={switchDoors}
              src={walmartRightDoor}
              alt=""
              style={{
                height: fridgeRef.current.clientHeight,
                transform:
                  fridgeRef.current.clientHeight < 547
                    ? 'scaleX(' + 580 / fridgeRef.current.clientHeight + ')'
                    : 'scaleY(' + fridgeRef.current.clientHeight / 547 + ')'
              }}
            />
          </div>
        )}
        {openDoors && (
          <div
            className={fridgeStyle.handler}
            style={{
              backgroundImage: 'url(' + require('./svg/handler.svg') + ')',
              display: 'none'
            }}
          ></div>
        )}
        {!settings.discrete && (
          <div className={fridgeStyle.curves}>
            <div
              className={fridgeStyle.curveLeft}
              style={{ maxHeight: questionSchema.get('answers_mask').size * 90 }}
            />
            <div
              className={fridgeStyle.curveRight}
              style={{ maxHeight: questionSchema.get('answers_mask').size * 90 }}
            />
            {questionSchema.get('answers_mask').size > 6 && (
              <Fragment>
                <div
                  className={fridgeStyle.curveLeftBottom}
                  style={{
                    height: (questionSchema.get('answers_mask').size - 6) * 96
                  }}
                />
                <div
                  className={fridgeStyle.curveRightBottom}
                  style={{
                    height: (questionSchema.get('answers_mask').size - 6) * 96
                  }}
                />
              </Fragment>
            )}
          </div>
        )}
        <div
          style={{
            backgroundImage: settings.discrete
              ? 'url(' +
                require(
                  questionSchema.get('double_width')
                    ? first
                      ? './svg/bottom-left.svg'
                      : './svg/bottom-right.svg'
                    : './svg/bottom.svg'
                ) +
                ')'
              : 'auto'
          }}
          className={fridgeStyle.bottom}
        />
      </div>
      <div className={fridgeStyle.fridgeBottom} />
    </div>
  )
})

FridgeBox.propTypes = {
  questionSchema: PropTypes.instanceOf(Map).isRequired,
  fullscreen: PropTypes.bool,
  doors: PropTypes.bool,
  mobile: PropTypes.bool,
  widthFactor: PropTypes.number.isRequired,
  cartCount: PropTypes.number,
  answers: PropTypes.instanceOf(OrderedMap).isRequired,
  width: PropTypes.number.isRequired,
  takenGoods: PropTypes.instanceOf(List).isRequired,
  onProductClick: PropTypes.func,
  closed: PropTypes.bool,
  hidden: PropTypes.bool,
  emulatedMobile: PropTypes.bool,
  alwaysOpen: PropTypes.bool,
  scale: PropTypes.number.isRequired,
  externalHover: PropTypes.bool,
  first: PropTypes.bool,
  generateImage: PropTypes.bool,
  margins: PropTypes.object,
  closeAnotherFridge: PropTypes.func,
  onHovered: PropTypes.func,
  onRender: PropTypes.func,
  answersImages: PropTypes.any,
  blockWidths: PropTypes.array
}

FridgeBox.displayName = 'FridgeBox'

export default memo(
  Fridge,
  (prevProps, nextProps) =>
    prevProps.questionSchema === nextProps.questionSchema &&
    prevProps.doors === nextProps.doors &&
    prevProps.mobile === nextProps.mobile &&
    prevProps.externalHover === nextProps.externalHover &&
    prevProps.widthFactor === nextProps.widthFactor &&
    prevProps.width === nextProps.width &&
    prevProps.fullscreen === nextProps.fullscreen &&
    prevProps.takenGoods === nextProps.takenGoods &&
    prevProps.emulatedMobile === nextProps.emulatedMobile &&
    prevProps.scale === nextProps.scale &&
    prevProps.margins === nextProps.margins &&
    prevProps.onHovered === nextProps.onHovered &&
    prevProps.cartCount === nextProps.cartCount &&
    prevProps.onProductClick === nextProps.onProductClick &&
    prevProps.blockWidths === nextProps.blockWidths &&
    prevProps.answers === nextProps.answers
)
